import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export default (function (theme) {
  return {
    root: {
      outline: 'none',
      '& .ace_editor': {
        width: '100%'
      }
    },
    Label: {
      width: 153,
      marginRight: 17,
      padding: '0 0 5px 0'
    },
    info: _objectSpread(_objectSpread({}, theme.typography.smallText), {}, {
      position: 'absolute',
      lineHeight: '20px',
      bottom: -21,
      color: theme.colors.neutral700
    }),
    error: _objectSpread(_objectSpread({}, theme.typography.smallText), {}, {
      position: 'absolute',
      lineHeight: '20px',
      bottom: -21,
      color: theme.colors.red500
    }),
    formControl: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: 320,
      lineHeight: 0
    },
    isReadOnly: {},
    vertical: {
      display: 'block',
      padding: '15px 0 10px 0',
      marginLeft: '0 !important',
      '& $formControl': {
        marginTop: 10
      },
      '& $Label': {
        width: '100%'
      }
    },
    horizontal: {
      display: 'flex',
      alignItems: 'flex-start',
      padding: '15px 0 10px 0'
    },
    isFullWidth: {
      '& $formControl': {
        width: '100%',
        flex: 1
      },
      '&$vertical $Label': {
        width: '100%'
      }
    },
    focused: {}
  };
});